// extracted by mini-css-extract-plugin
module.exports = {"codemirror__label":"style__codemirror__label___2wVEr"};